import '../../styles/sections/dynamic-cart.scss';

import { changeCart, upgradeProduct } from '../utils/cart';

class DynamicCart extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('[data-close-dynamic-cart]');
    this.itemCount = this.querySelector('[data-title-item-count]');
    this.wrapper = this.querySelector('[data-dynamic-cart-wrapper]');
    this.itemsList = this.querySelector('[data-items-list]');
    this.cartFooter = this.querySelector('[data-cart-footer]');
    this.form = this.querySelector('form');
    this.upsellContainer = this.querySelector('.upsell');
    this.upsellButtons = this.querySelectorAll('[data-upsell-button]');

    this.closeButton.addEventListener('click', this.closeCart.bind(this));

    window.addEventListener('dynamic-cart-loading', this.loading.bind(this));
    window.addEventListener('dynamic-cart-open', this.openCart.bind(this));
    window.addEventListener('ajax-cart', this.updateCart.bind(this));

    this.addEventListener('click', this.closeCart.bind(this));
    this.wrapper.addEventListener('click', (event) => {event.stopPropagation()});

    this.initItemsInteractions();

    if (localStorage.getItem('trainer')) {
      this.setTrainer();
    }
  }

  initItemsInteractions() {
    this.quantityInputs = Array.from(this.querySelectorAll('[data-input-item-key]'));
    this.removeButtons = Array.from(this.querySelectorAll('[data-remove-item]'));
    this.upsellButtons = Array.from(this.querySelectorAll('[data-upsell-button]'));

    this.quantityChangeFunction = this.quantityChange.bind(this);

    this.quantityInputs.forEach(input => {
      input.addEventListener('change', this.quantityChangeFunction);
    });

    this.removeButtons.forEach(button => {
      button.addEventListener('click', this.removeItem);
    });

    this.upsellButtons.forEach(button => {
      button.addEventListener('click', this.upgradeItem);
    });

    const config = { attributes: true, childList: true, subtree: true };

    const callback = (list, observer) => {
      window.i18next.translateAllHtml(document.querySelector('.upsell'));
    }

    const observer = new MutationObserver(callback);
    observer.observe(document.querySelector('.upsell'), config);

    if (localStorage.getItem('trainer')) {
      this.setTrainer();
    }
  }

  closeCart(event) {
    event.preventDefault();
    this.removeAttribute('opened');
    this.setAttribute('closed', '');
  }

  openCart() {
    this.setAttribute('opened', '');
    this.removeAttribute('closed');
  }

  loading() {
    this.form.classList.add('loading-state', "loading");
  }

  quantityChange(event) {
    const currentQuantityInput = event.currentTarget;

    changeCart(currentQuantityInput.dataset.inputItemKey, currentQuantityInput.value);
  }

  removeItem(event) {
    event.preventDefault();

    const currentQuantityInput = event.currentTarget;

    changeCart(currentQuantityInput.dataset.removeItem, 0);
  }

  upgradeItem(event) {
    event.preventDefault();

    let upsellDataJson = event.currentTarget.querySelector('[data-upsell-data]');

    if (upsellDataJson) {
      let upsellData = JSON.parse(upsellDataJson.innerHTML);

      let variant = upsellData.product.variants[0];
      let upgradeId = variant.id;
      let sellingPlan = variant.selling_plan_allocations[0]?.selling_plan_id;

      upgradeProduct(upsellData.id, upgradeId, upsellData.quantity, sellingPlan);
    }
  }

  updateCart(event) {
    const sectionHTML = event.detail.cartSections['dynamic-cart'];

    const tempElement = document.createElement('div');
    tempElement.innerHTML = sectionHTML.replaceAll('dynamic-cart>', 'div>'); //replace is important otherwise the constructor is called again because of the element inside the tempElement and adds duplicated events

    const updatedCartItemsHTML = tempElement.querySelector('[data-items-list]').innerHTML;
    const cartFooterHTML = tempElement.querySelector('[data-cart-footer]').innerHTML;
    const itemCountText = tempElement.querySelector('[data-title-item-count]').textContent;

    this.itemsList.innerHTML = updatedCartItemsHTML;
    this.cartFooter.innerHTML = cartFooterHTML;
    this.itemCount.textContent = itemCountText;

    this.form.classList.remove('loading-state', "loading");

    this.initItemsInteractions();

    this.setTrainer();
  }

  setTrainer() {
    const selector = this.querySelector('[data-trainer-selector]');

    if (selector) {
      const options = Array.from(selector.querySelectorAll('option'));
      const trainer = localStorage.getItem('trainer');

      const trainerIsSelectable = options.find( option => option.value === trainer);

      if (trainerIsSelectable) {
        selector.value = trainer;
      }
    }
  }
}

customElements.define('dynamic-cart', DynamicCart)
